import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import * as styles from './index.module.css'
import { GradientBorder } from '../commons'
import Button from '../Button/'
import Link from '../Link'

const WorkWithUs = (props) => {
  return (
    <div className="wrapper">
      <div className={styles.container}>
        <GradientBorder
          height="1px"
          style={{ marginBottom: '15px' }}
          className={styles.mobileGrad}
        />

        <div className={styles.imageContainer}>
          <GatsbyImage
            image={props.images[0].gatsbyImageData}
            style={{ height: '100%', width: '100%' }}
            alt={props?.images[0]?.description}
          />
        </div>

        <div className={styles.description}>
          <GradientBorder
            height="1px"
            style={{ marginBottom: '29px' }}
            className={styles.normalGrad}
          />

          <h2 className={styles.title}>{props.title}</h2>
          <div className={styles.jobIncentive}>{props.subtitle.subtitle}</div>
          <Link to={props.ctaUrl}>
            <Button
              inverted
              style={{
                margin: '2.5rem 0 0',
                width:
                  typeof window !== `undefined` && window.innerWidth > 450
                    ? 'auto'
                    : '100%',
              }}
            >
              {props.ctaText}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default WorkWithUs
